// src/helpers/factories/settings/generalSettingsFactory.ts
var CLOCK_IN_MODES_OPTIONS = [
  "auto" /* AUTO */,
  "manual" /* MANUAL */,
  "prompt" /* PROMPT */
];
var clockInModeFactory = (t) => [
  {
    label: t(
      "settingsModule.generalSettings.generalSettings.clockInMode.values.auto"
    ),
    value: CLOCK_IN_MODES_OPTIONS.indexOf("auto" /* AUTO */) + 1
  },
  {
    label: t(
      "settingsModule.generalSettings.generalSettings.clockInMode.values.manual"
    ),
    value: CLOCK_IN_MODES_OPTIONS.indexOf("manual" /* MANUAL */) + 1
  },
  {
    label: t(
      "settingsModule.generalSettings.generalSettings.clockInMode.values.prompt"
    ),
    value: CLOCK_IN_MODES_OPTIONS.indexOf("prompt" /* PROMPT */) + 1
  }
];

export { CLOCK_IN_MODES_OPTIONS, clockInModeFactory };
